var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3V20.25M12 20.25C10.528 20.25 9.118 20.515 7.815 21M12 20.25C13.472 20.25 14.882 20.515 16.185 21M18.75 4.97C16.5137 4.65611 14.2582 4.49906 12 4.5C9.709 4.5 7.455 4.66 5.25 4.97M18.75 4.97C19.76 5.113 20.76 5.287 21.75 5.49M18.75 4.97L21.37 15.696C21.492 16.195 21.264 16.724 20.781 16.898C20.1294 17.1319 19.4423 17.2509 18.75 17.25C18.0577 17.2509 17.3706 17.1319 16.719 16.898C16.236 16.724 16.008 16.195 16.129 15.696L18.75 4.971V4.97ZM5.25 4.97C4.24 5.113 3.24 5.287 2.25 5.49M5.25 4.97L7.87 15.696C7.992 16.195 7.764 16.724 7.281 16.898C6.62943 17.1318 5.94226 17.2509 5.25 17.25C4.55774 17.2509 3.87057 17.1318 3.219 16.898C2.736 16.724 2.508 16.195 2.629 15.696L5.25 4.971V4.97Z",
    fill: "none",
    stroke: "inherit",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/scale.6ce6adab9651ae1dc67caa989edb4ced.svg";
export { ForwardRef as ReactComponent };